import React from 'react';
import s from './spinner.module.scss';

export default function SpinnerComponent({ size, ...props }) {
    return (
        <div className={`${s.loader}`} style={{ fontSize: size }}>
        </div>
    );
}